
<div class="content-width" [style.height.px]="chartHeight">
  <canvas *ngIf="isChartActive" id="momentumChart" #momentumChart baseChart
                [data]="lineChartData"
                [options]="lineChartOptions"
                [type]="lineChartType"></canvas>
</div>
